import { actionTypes } from '../actions/order';
import HttpService from "../../services/HttpService";

export const receiveSimpleOrder = (order) => ({type:actionTypes.receiveSimpleOrder, order});
export const receiveOrder = (order,patient,studies,measurements, samples) => ({ type: actionTypes.receiveOrder, order,patient,studies,measurements, samples });


export const setOrder = (order) => ({type: actionTypes.setOrder, order});
export const addStudy = (study) => ({type: actionTypes.addStudy, study});
export const reAddStudy = (study) => ({type: actionTypes.reAddStudy, study});
export const editStudy = (study,oldEfectorId) => ({type: actionTypes.editStudy, study,oldEfectorId});
export const removeStudy = (study) => ({type: actionTypes.removeStudy, study});
export const clearStudies = () => ({type: actionTypes.clearStudies});

const hasMeasurementType = (measurementTypes, measurementType) => {
    return measurementTypes.some(mt => (mt.code && mt.code === measurementType.code) || (mt.id && mt.id === measurementType.id));
}

const matchesRelation = (item, relation) => {
    if (!item || !relation) {
        return false;
    }

    const itemCode = item.code;
    const itemId = item.id;

    if (typeof relation === 'string' || typeof relation === 'number') {
        return String(relation) === String(itemCode) || String(relation) === String(itemId);
    }

    return String(relation.code) === String(itemCode)
        || String(relation.id) === String(itemId);
}

const enrichStudyTypeWithMeasurements = (studyType, catalogMeasurementTypes) => {
    const measurementTypes = [...(studyType.measurement_types || [])];
    const sampleTypes = (studyType.sample_types || []).map(sampleType => ({
        ...sampleType,
        measurement_types: [...(sampleType.measurement_types || [])]
    }));

    catalogMeasurementTypes.forEach(measurementType => {
        const studyRelations = measurementType.studyTypes || measurementType.study_types || [];
        if (studyRelations.some(relation => matchesRelation(studyType, relation)) && !hasMeasurementType(measurementTypes, measurementType)) {
            measurementTypes.push({...measurementType});
        }

        const sampleRelations = measurementType.sampleTypes || measurementType.sample_types || [];
        sampleTypes.forEach(sampleType => {
            if (sampleRelations.some(relation => matchesRelation(sampleType, relation)) && !hasMeasurementType(sampleType.measurement_types, measurementType)) {
                sampleType.measurement_types.push({...measurementType});
            }
        });
    });

    return {
        ...studyType,
        measurement_types: measurementTypes,
        sample_types: sampleTypes,
    };
}

export const addStudyWithMeasurements = (study) => {
    return (dispatch, getState) => {
        const catalogMeasurementTypes = getState()?.catalogs?.measurementTypes || [];

        if (!study?.study_type) {
            dispatch(addStudy(study));
            return;
        }

        const enrichedStudyType = enrichStudyTypeWithMeasurements(study.study_type, catalogMeasurementTypes);
        dispatch(addStudy({
            ...study,
            study_type: enrichedStudyType,
        }));
    }
}

export const addStudies = (studies) => {
    return (dispatch) => {
        studies.forEach(study => 
            dispatch(addStudyWithMeasurements(study)));
    }
}

export const fetchOrder = (orderId) => {
    return (dispatch) => {

        dispatch({ type: actionTypes.fetchOrder });

        return HttpService.getInstance().getData(`orders/${orderId}`, 'user-token')
        .then(response => {
            const {order,patient,studies,measurements,samples} = response.data;
            dispatch(receiveOrder(order,patient,studies,measurements,samples));
        })
    }
}

export const fetchCustomerOrder = (customerId, orderId) => {
    return (dispatch) => {

        dispatch({ type: actionTypes.fetchOrder });

        return HttpService.getInstance().getData(`customers/${customerId}/orders/${orderId}`, 'user-token')
            .then(response => {
                const {order,patient,studies,measurements,samples} = response.data;
                dispatch(receiveOrder(order,patient,studies,measurements,samples));
        })
    }
}

export const createCustomerOrder = (customer, order,studies,samples,measurements) => {
    return (dispatch) => {

        dispatch({ type: actionTypes.createOrder });
        
        const body = {order:order,studies:studies,samples:samples,measurements:measurements};
        return HttpService.getInstance().postData(body,`customers/${customer}/orders`, 'user-token')
            .then(response => {
                const {order,patient,studies,measurements,samples} = response.data;
                dispatch(receiveOrder(order,patient,studies,measurements,samples));
        })
    }
}

export const removeCustomerOrder = (customer, order) => {
    return (dispatch) => {
 
        return HttpService.getInstance().deleteData(`customers/${customer}/orders/${order}`, 'user-token')
            .then(response => {
                const order = response.data;
                dispatch({ type: actionTypes.removeOrder, order});
        })
    }
}

export const createCustomerFastSample = (customer, order,sample,studies,samples,measurements) => {
    return (dispatch) => {

        dispatch({ type: actionTypes.createFastSample });
        
        const body = {order:order,sample:sample,studies:studies,samples:samples,measurements:measurements};
        return HttpService.getInstance().postData(body,`customers/${customer}/fast-samples`, 'user-token')
            .then(response => {
                const {order,patient,studies,measurements,samples} = response.data;
                dispatch(receiveOrder(order,patient,studies,measurements,samples));
        })
    }
}

export const updateCustomerOrder = (customer, order, studies,samples,measurements) => {
    return (dispatch) => {

        const body = {order:order,studies:studies,samples:samples, measurements:measurements};
        return HttpService.getInstance().putData(body, `customers/${customer}/orders`, 'user-token')
            .then(response => {
                const {order,patient,studies,measurements,samples} = response.data;
                dispatch(receiveOrder(order,patient,studies,measurements,samples));
        })
    }
}

export const updateOrder = (order, studies,samples,measurements) => {
    return (dispatch) => {

        const body = {order:order,studies:studies,samples:samples, measurements:measurements};
        return HttpService.getInstance().putData(body, `orders/${order.id}`, 'user-token')
            .then(response => {
                const {order,patient,studies,measurements,samples} = response.data;
                dispatch(receiveOrder(order,patient,studies,measurements,samples));
        })
    }
}